import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["readOnlyReason", "children", "titleOverride", "disableOverride", "isUngatedForPermissions", "scope", "hasDeleteScope"];
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { readOnlyReasonProp } from '../../constants/propTypes';
import { getReadOnlyReason } from '../../selectors/Permissions';
import { selectIsUngatedForPermissions, selectUserHasFileManagerDeleteScope } from '../../selectors/Auth';
import { getReadOnlyPermissionMessaging } from '../../utils/notifications';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILE_MANAGER_DELETE_SCOPE, FILE_MANAGER_WRITE_SCOPE } from '../../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  children: PropTypes.node.isRequired,
  isUngatedForPermissions: PropTypes.bool.isRequired,
  hasDeleteScope: PropTypes.bool.isRequired,
  titleOverride: PropTypes.node,
  readOnlyReason: readOnlyReasonProp,
  disableOverride: PropTypes.bool,
  scope: PropTypes.oneOf([FILE_MANAGER_WRITE_SCOPE, FILE_MANAGER_DELETE_SCOPE])
};
const ScopedFeatureTooltip = props => {
  const {
      readOnlyReason,
      children,
      titleOverride,
      disableOverride,
      isUngatedForPermissions,
      scope,
      hasDeleteScope
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const enforcingScope = scope || FILE_MANAGER_WRITE_SCOPE;
  const shouldDisableTooltip = () => {
    if (enforcingScope === FILE_MANAGER_WRITE_SCOPE || readOnlyReason) {
      return !readOnlyReason;
    }
    if (enforcingScope === FILE_MANAGER_DELETE_SCOPE) {
      return !(isUngatedForPermissions && !hasDeleteScope);
    }
    return true;
  };
  let disabled = shouldDisableTooltip();
  const getTooltipTitle = () => {
    if (disabled) {
      return null;
    }
    if (readOnlyReason) {
      return getReadOnlyPermissionMessaging(readOnlyReason).explanation;
    }
    if (enforcingScope === FILE_MANAGER_DELETE_SCOPE && isUngatedForPermissions && !hasDeleteScope) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "FileManagerCore.permissions.noDeleteReason"
      });
    }
    return null;
  };
  let title;
  title = getTooltipTitle();
  if (titleOverride) {
    title = titleOverride;
    disabled = false;
  }
  if (disableOverride) {
    disabled = disableOverride;
  }
  return /*#__PURE__*/_jsx(UITooltip, Object.assign({
    title: title,
    disabled: disabled,
    "data-test-id": "scoped-feature-tooltip",
    "data-test-read-only-reason": readOnlyReason
  }, rest, {
    children: children
  }));
};
ScopedFeatureTooltip.propTypes = propTypes;
const mapStateToProps = state => ({
  readOnlyReason: getReadOnlyReason(state),
  isUngatedForPermissions: selectIsUngatedForPermissions(state),
  hasDeleteScope: selectUserHasFileManagerDeleteScope(state)
});
export default connect(mapStateToProps, {})(ScopedFeatureTooltip);